import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { injectIntl } from 'react-intl';

import FlashesRenderer from 'src/components/Flashes/FlashesRenderer';
import AuthenticatedErrorNavigation from 'src/components/Navigation/AuthenticatedErrorNavigation';
import Footer from 'src/enosikit/components/Footer';

/**
 * HTTP403 component
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {object} props.intl
 * @returns {React.ReactComponentElement} - HTTP403 component
 */
function HTTP403({ children = null, intl }) {
  const pageTitle = intl.formatMessage({ id: 'http403.page_title.label', defaultMessage: 'Enosi - Access Denied' });
  const header = intl.formatMessage({ id: 'http403.header.text', defaultMessage: 'Access denied' });
  const content = intl.formatMessage({ id: 'http403.content.text', defaultMessage: 'You are not authorized to be here.' });
  const backToDashboardLabel = intl.formatMessage({ id: 'http403.back_to_dashboard.link.label', defaultMessage: 'Back to dashboard' });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
      </Helmet>

      <div className="flex flex-column" style={{ minHeight: '80vh' }}>
        <AuthenticatedErrorNavigation />
        <FlashesRenderer />
        <div className="flex-auto">
          <div className="container text-center">
            <h1>{header}</h1>
            <p>{content}</p>
            <Link to="/properties" className="btn btn-primary">{backToDashboardLabel}</Link>
            {children}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

HTTP403.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default injectIntl(HTTP403);
